var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom-navigation", class: { hidden: _vm.isHidden } },
    [
      _c(
        "v-bottom-nav",
        { attrs: { app: "", fixed: "", value: true, height: "60" } },
        [
          _c(
            "router-link",
            { staticClass: "btn", attrs: { to: "/" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "promotions-v2",
                  class: { active: _vm.activeHome },
                  attrs: { ripple: false, flat: "", value: "favorites" },
                  on: {
                    click: function($event) {
                      return _vm.toggleHome()
                    }
                  }
                },
                [
                  _c("icon", { attrs: { name: "icon-home" } }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v("Home")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "menu",
              class: { active: _vm.dialogSportsMenu },
              attrs: {
                ripple: false,
                flat: "",
                color: "teal",
                value: "recent"
              },
              on: {
                click: function($event) {
                  return _vm.toggleMenu()
                }
              }
            },
            [
              _c("icon", { attrs: { name: "icon-sports-atoz" } }),
              _vm._v(" "),
              _c("span", { staticClass: "bottom_nav_text" }, [
                _vm._v(_vm._s(_vm.$t("Sports.Sports")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.navigationType
            ? _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      return _vm.specialLink()
                    }
                  }
                },
                [
                  _c("icon", {
                    attrs: { name: _vm.navigationName, colorName: "dark" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v("Promotions")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c(
                "v-btn",
                {
                  staticClass: "account",
                  class: { active: _vm.dialogMyAccount },
                  attrs: { ripple: false, flat: "", value: "nearby" },
                  on: {
                    click: function($event) {
                      return _vm.toggleMyAccount()
                    }
                  }
                },
                [
                  _c("icon", {
                    attrs: {
                      name: "icon-user",
                      colorName: _vm.dialogMyAccount ? "blue" : "dark"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("MyAccount.Account")))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.mobileBigAndBelow
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "dialog-menu",
              attrs: {
                app: "",
                fixed: "",
                "disable-resize-watcher": "",
                "disable-route-watcher": ""
              },
              model: {
                value: _vm.dialogSportsMenu,
                callback: function($$v) {
                  _vm.dialogSportsMenu = $$v
                },
                expression: "dialogSportsMenu"
              }
            },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c(
                    "v-layout",
                    { staticClass: "title" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "logo-wrapper" },
                        [
                          !_vm.isLoggedIn ? _c("logo") : _vm._e(),
                          _vm._v(" "),
                          _vm.isLoggedIn
                            ? _c("logo", { attrs: { mode: "sign" } })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isLoggedIn
                        ? _c("v-flex", [_c("account-info-component")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "close" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "close",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleMenu()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "curve" }),
              _vm._v(" "),
              _c("sports-menu")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b557933", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b557933","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/BottomNavigation.vue
// module id = null
// module chunks = 